/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AudienceFilterFromJSON, AudienceFilterToJSON } from './AudienceFilter';
/**
 * @export
 */
export const CreateCampaignRequestTemplateEnum = {
    legalChange: 'legal_change'
};
/**
 * Check if a given object implements the CreateCampaignRequest interface.
 */
export function instanceOfCreateCampaignRequest(value) {
    if (!('documentVersion' in value) || value['documentVersion'] === undefined)
        return false;
    if (!('params' in value) || value['params'] === undefined)
        return false;
    if (!('template' in value) || value['template'] === undefined)
        return false;
    return true;
}
export function CreateCampaignRequestFromJSON(json) {
    return CreateCampaignRequestFromJSONTyped(json, false);
}
export function CreateCampaignRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'audienceFilter': json['audience_filter'] == null ? undefined : AudienceFilterFromJSON(json['audience_filter']),
        'documentVersion': json['document_version'],
        'params': json['params'],
        'template': json['template'],
    };
}
export function CreateCampaignRequestToJSON(json) {
    return CreateCampaignRequestToJSONTyped(json, false);
}
export function CreateCampaignRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'audience_filter': AudienceFilterToJSON(value['audienceFilter']),
        'document_version': value['documentVersion'],
        'params': value['params'],
        'template': value['template'],
    };
}
